import { render, staticRenderFns } from "./table_body_no_article.vue?vue&type=template&id=8b838188&lang=pug"
import script from "./table_body_no_article.vue?vue&type=script&lang=js"
export * from "./table_body_no_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports